import React, { Component } from 'react'
import Swal from 'sweetalert2';
import { subUserById, subUserCreate, subUserUpdate } from '../../action/auth';
import UserCreate from '../../old_Components/ManageSubusers/UserCreate'
import constant from '../../constant'
export default class userCreate extends Component {
    constructor(props){
            super(props);
            this.state = {
             
            }
    }

    componentDidMount(){
        document.title = constant.title.UserCreate
      }

    onSubmit = (data) =>{
        subUserCreate(data).then((res) => {
          if (res.status) {
            Swal.fire({
              icon: "success",
              text: "Sub user created successfully",
              timer: 1500,
              showCancelButton: false,
              showConfirmButton: false
            });
            this.props.history.push(constant.component.UserList.url);
          } else {
            Swal.fire({
              icon: "error",
              text: res.error,
              timer: 1500,
              showCancelButton: false,
              showConfirmButton: false
            });
          }
      })     
    }

  render() {
    return (
      <React.Fragment>
        <UserCreate onSubmit={(data)=>this.onSubmit(data)} id={null} details={null}/>
      </React.Fragment>
    )
  }
}
